import React, { Container } from 'react'
import {useHistory} from "react-router-dom"
import { Nav } from 'reactstrap';
import "./header.css"
import Navb from "./Navb"

function Header() {
    let history = useHistory();
    const home = () => {
        history.push("/")
        localStorage.clear();
    }
    return (
        <div className = "row">
        <div className = "col-md-12">
        <div className = "header__bar" onClick = {home}>  
            <span className="first__arraycolor">xxxxxxxxxxxxxx</span> 
            <span className="second__arraycolor">xxxxxxxxxxxxxx</span>
            <span className="third__arraycolor">xxxxxxxxxxxxxx</span>
            <span className="fourth__arraycolor">xxxxxxxxxxxxxx</span>
            <span className="fifth__arraycolor">xxxxxxxxxxxxxx</span>
            <span className="sixth__arraycolor">xxxxxxxxxxxxxx</span>
            
        </div>
            <Navb/> 
        </div>
        </div>
    )
}

export default Header
